document.querySelectorAll('[data-variant-select]').forEach(select => {
  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const section = select.closest('.product-details');
    const button = section.querySelector('[data-add-button]');
    section.querySelector('[data-product-price]').textContent = option.dataset.price;
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldText : button.dataset.addText;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});

const menuToggle=document.querySelector('[data-menu-toggle]');
const navigation=document.getElementById('FashionNavigation');
menuToggle?.addEventListener('click',()=>{const open=menuToggle.getAttribute('aria-expanded')!=='true';menuToggle.setAttribute('aria-expanded',String(open));navigation.classList.toggle('is-open',open);});
document.addEventListener('click',event=>{document.querySelectorAll('.nav-group[open],.device-quick[open]').forEach(group=>{if(!group.contains(event.target))group.removeAttribute('open');});});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.nav-group[open],.device-quick[open]').forEach(group=>group.removeAttribute('open'));if(navigation?.classList.contains('is-open')){navigation.classList.remove('is-open');menuToggle.setAttribute('aria-expanded','false');menuToggle.focus();}}});

// Reopen Shopify's native preferences dialog only on a visitor's request.
document.querySelectorAll('[data-cookie-preferences]').forEach(button=>{
  button.addEventListener('click',async()=>{
    button.disabled=true;
    try {
      if(typeof window.privacyBanner?.showPreferences!=='function') {
        await new Promise((resolve,reject)=>{
          let script=document.querySelector('script[data-native-privacy-banner]');
          if(script){script.addEventListener('load',resolve,{once:true});script.addEventListener('error',reject,{once:true});return;}
          script=document.createElement('script');
          script.src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.dataset.nativePrivacyBanner='true';script.onload=resolve;script.onerror=reject;document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
      document.querySelectorAll('[data-privacy-status]').forEach(status=>{status.textContent='';});
    }catch(error){
      document.querySelectorAll('[data-privacy-status]').forEach(status=>{status.textContent='Cookie preferences could not open. Please refresh this page or contact lrip8179@gmail.com for help with your privacy choices.';});
    }finally{button.disabled=false;}
  });
});
